<template>
  <div class="item-object-wrapper">
    <div class="bar-wrapper" v-if="showMenu">
      <div class="bar-wrapper__box">
        <router-link to="/gamefy" v-if="showGamefyFlag">
          <div
            @click="modalStatus(false)"
            class="bar-wrapper__item"
            :class="isGamefyCardActive ? 'bar-wrapper__item--active': ''"
          >
            Points
          </div>
        </router-link>
        <router-link to="/HabitsDashboard">
          <div
            @click="modalStatus(false)"
            class="bar-wrapper__item"
            :class="isHabitCardActive ? 'bar-wrapper__item--active': ''"
          >
            {{ $t(`${translationPath}.habits`) }}
          </div>
        </router-link>
        <span
          @click="modalStatus(true)"
          class="bar-wrapper__item"
          :class="(!isHabitCardActive && !isGamefyCardActive) ? 'bar-wrapper__item--active': ''"
        >
          Menu
        </span>
      </div>
    </div>
    <div v-if="showModal">
      <div class="wrapper-menu">
        <div class="menu-list">
          <div class="menu-items-wrapper">
            <div
              @click="showLoginModal"
              style="margin-top: 40px;"
              class="display-flex flex-align-item-center mb-5">
              <font-awesome-icon style="width: 50px;" size="2x" icon="cog"
              class="mr-4 ml-2"/> {{ $t(`${translationPath}.settings`) }}
            </div>
            <div
              @click="clickFeedback"
              class="display-flex flex-align-item-center mb-5">
              <font-awesome-icon style="width: 50px;" size="2x" icon="comment-dots"
              class="mr-4 ml-2"/> {{ $t(`${translationPath}.feedback`) }}
            </div>
            <div
              @click="addWebhook"
              class="display-flex flex-align-item-center mb-5">
              <font-awesome-icon style="width: 50px;" size="2x" icon="anchor"
              class="mr-4 ml-2"/> Add webhook for activitis
            </div>
            <!-- <router-link to="/discord">
              <div
                @click="modalStatus(false)"
                class="display-flex flex-align-item-center mb-5">
                <font-awesome-icon style="width: 50px;" size="2x" :icon="['fab', 'discord']"
                class="mr-4 ml-2"/> {{ $t(`${translationPath}.discord`) }}
              </div>
            </router-link> -->
            <!-- <router-link to="/news">
              <div
                @click="modalStatus(false)"
                class="display-flex flex-align-item-center mb-5">
                <font-awesome-icon style="width: 50px;" size="2x" :icon="['fas', 'bell']"
                class="mr-4 ml-2"/> {{ $t(`${translationPath}.news`) }}
              </div>
            </router-link> -->
            <router-link to="/support-us">
            <div
              @click="modalStatus(false)"
              class="display-flex flex-align-item-center mb-5">
                <font-awesome-icon
                  style="width: 50px;"
                  size="2x"
                  :icon="['fa', 'briefcase-medical']"
                  class="mr-4 ml-2"/>{{ $t('supportUs') }}
              </div>
            </router-link>
            <router-link to="/qrcode-generator">
              <div
                @click="modalStatus(false)"
                class="display-flex flex-align-item-center mb-2">
                <font-awesome-icon style="width: 50px;" size="2x" :icon="['fa', 'qrcode']"
                class="mr-4 ml-2"/> QR codes
              </div>
            </router-link>
            <b-field style="margin-top: 40px">
              <b-checkbox @input="showGamefy">Show gamefy (experimental)</b-checkbox>
            </b-field>

             <!-- <router-link to="/Lotery">
              <div
                @click="modalStatus(false)"
                class="display-flex flex-align-item-center flex-justify-contety-space-between mb-2">
                <font-awesome-icon size="2x" icon="dice" /> Loteria
              </div>
             </router-link> -->
            <!-- <router-link to="/NotesBoard">
              <div
                @click="modalStatus(false)"
                class="display-flex flex-align-item-center flex-justify-contety-space-between mb-2">
                <font-awesome-icon size="2x" icon="file" /> Notatki
              </div>
            </router-link> -->
          </div>
        </div>
      </div>
      <div class="modal-background" @click="modalStatus(false)"/>
    </div>
    <LoginModal />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import LoginModal from './LoginModal.vue';

export default {
  name: 'MainMenu',
  props: {
    showMenu: Boolean,
  },
  data() {
    return {
      showModal: false,
      activeAvatar: '',
      translationPath: 'menu',
      showGamefyCount: 0,
      showGamefyFlag: false,
    };
  },
  components: {
    LoginModal,
  },
  computed: {
    ...mapState({
      user: (state) => state.userStore.user,
      haveNotes: (state) => state.userStore.haveNotes,
      nick: (state) => state.userStore.nick,
    }),
    isHabitCardActive() {
      return this.$route.name === 'HabitsDashboard';
    },
    isGamefyCardActive() {
      return this.$route.name === 'Gamefy';
    },
    userLetter() {
      return (typeof this.nick === 'string') ? this.nick.charAt(0) : '?';
    },
  },
  methods: {
    clickFeedback(e) {
      this.modalStatus(false);
      window.feedbackfin.open(e);
    },
    ...mapActions({
      setLoginModalDisplay: 'userStore/setLoginModalDisplay',
      setParamToUser: 'userStore/setParamToUser',
    }),
    modalStatus(status) {
      this.showModal = status;
    },
    showLoginModal() {
      this.setLoginModalDisplay(true);
      this.modalStatus(false);
    },
    addWebhook() {
      const webhook = prompt('Paste the webhook.');
      if (!webhook) return;
      alert('Webhook added');
      this.setParamToUser({ name: 'webhookForActivitys', value: webhook });
    },
    showGamefy() {
      this.showGamefyCount += 1;
      if (this.showGamefyCount > 10) {
        // save to localstorage flag for show gamefy
        localStorage.setItem('showGamefyFlag', true);
      }
    },
  },
  mounted() {
    this.showGamefyFlag = localStorage.getItem('showGamefyFlag');
  },
};
</script>

<style scoped lang="scss">
.bar-wrapper {
  position: fixed;
  display: flex;
  justify-content: center;
  top: 10px;
  left: 0;
  width: 100%;
  z-index: 5;
  &__box {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 40px;
    background: $background-color;
    border-radius: 10px;
  }
  &__item {
    color: rgba(255, 255, 255, 0.782);
    font-weight: 800;
    margin: 0 5px;
    padding: 5px 10px;
    &--active {
      background: $background-light-color;
      border-radius: 5px;
      color: white;
    }
  }
}
.wrapper-menu {
  position: fixed;
  top:0;
  right: 0;
  z-index: 999;
}
.modal-background {
  width: 100%;
  height: 100%;
  z-index: 998;
  backdrop-filter: blur(16px) saturate(180%);
  -webkit-backdrop-filter: blur(16px) saturate(180%);
  position: fixed;
}
.menu-list {
  width: 70vw;
  height: 100vh;
  min-width: 229px;
  padding: 20px 30px;
  background: $background-light-color;
  border-bottom-left-radius: 80px;
  border-top-left-radius: 80px;
  a {
    color: $font-light-color;
    padding: 0;
  }
  a:hover {
    background: transparent;
    padding: 0;
  }
  svg {
    color: $font-brand-color;
  }
}
.avatar {
  width: 56px;
  height: 56px;
  margin: 0 auto;
  border: black 1px solid;
  border-radius: 56px;
  background-size: cover;
}
.menu-items-wrapper {
  width: 90%;
  margin: 0 auto;
  font-weight: 700;
}
.friend-box {
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    -webkit-user-select: none; /* Safari */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+/Edge */
    user-select: none; /* Standard */

    &--person {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-left: 9px;
      margin-bottom: 10px;
    }
    &--text {
      font-weight: 600;
    }
    &--avatar {
      width: 50px;
      height: 50px;
      border-radius: 100px;
      border: 1px black solid;
      background-size: cover;
      background-color: $background-light-color;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 600;
      text-transform: uppercase;
      font-size: 25px;
    }
  }
</style>
